'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileUrl = getFileUrl;
exports.default = init;
var baseFileUrl = exports.baseFileUrl = 'https://storage.googleapis.com';

function getFileUrl(storageBucket) {
  if (!storageBucket) return function () {
    return null;
  };
  return function (fileName) {
    return [baseFileUrl, storageBucket, fileName].join('/');
  };
}

function init(fireApp, _ref) {
  var doSignInAnon = _ref.doSignInAnon,
      storageBucket = _ref.storageBucket;
  var db = fireApp.database().ref();
  return {
    auth: fireApp.auth(),
    db: db,
    doSignInAnon: doSignInAnon || false,
    entity: db.child('entity'),
    getFileUrl: getFileUrl(storageBucket)
  };
}